// =======================================================
// Quick Access
// =======================================================
// Variable
const body                  = document.body
const QAccess               = document.querySelector('#js-q-access')
const QAccessOpen           = QAccess.querySelector('#js-QAccessOpen')
const QAccessClose          = QAccess.querySelector('#js-QAccessClose');
const QAccessCloseAlly      = QAccess.querySelector('#js-QAccessClose--ally')
const access_links          = QAccess.querySelectorAll('.access__link')


if (QAccess) {

    // add tabindex -1 on all links in Quick Access
    access_links.forEach(function (access_link) {
        access_link.setAttribute('tabindex', -1)
    });

    // Open function Quick Access
    function OpenQaccess(QAccess) {
        QAccess.classList.toggle('js-open')
        // body.classList.add('js-open');

        QAccessClose.setAttribute('tabindex', 0)
        QAccessCloseAlly.setAttribute('tabindex', 0)

        access_links.forEach(function(access_link) {
            access_link.setAttribute('tabindex', 0)
        });
    }

    // Close function Quick Access
    function CloseQaccess(QAccess) {
        QAccess.classList.remove('js-open')
        // body.classList.remove('js-open')

        QAccessClose.setAttribute('tabindex', -1)
        QAccessCloseAlly.setAttribute('tabindex', -1)

        access_links.forEach(function(access_link) {
            access_link.setAttribute('tabindex', -1)
        });
    }

    // If exist and click QAccess Open btn : Quick Access Open
    !!QAccessOpen && QAccessOpen.addEventListener('click', function() {
        OpenQaccess(QAccess)
    })

    // If exist and click QAccess Close btn : Quick Access Close
    !!QAccessClose && QAccessClose.addEventListener('click', function() {
        CloseQaccess(QAccess)
    })

    // If exist and click QAccess Close btn A11y : Quick Access Close
    !!QAccessCloseAlly && QAccessCloseAlly.addEventListener('click', function() {
        CloseQaccess(QAccess)
    })

    // If exist and click outside QAccess : Quick Access Close
    document.addEventListener("mouseup", function(event) {
        if (!QAccess.contains(event.target)) {
            CloseQaccess(QAccess)
        }
    })
}

